import * as React from 'react';
import { useContext } from 'react';

import type { ApolloError } from 'apollo-client';

import type { SkillTag } from '@coursera/grpc-types-skills/coursera/proto/skills/tags/v2/skill_tag';

type EnterpriseLearningPathSkillsContextType =
  | {
      courseSkillTagsMap?: Record<string, SkillTag[]> | null;
      isSkillTagsLoading?: boolean;
      error?: ApolloError;
    }
  | undefined;

const EnterpriseLearningPathSkillsContext = React.createContext<EnterpriseLearningPathSkillsContextType>(undefined);

export const useSkillTagsData = () => {
  const context = useContext(EnterpriseLearningPathSkillsContext);

  return context?.courseSkillTagsMap;
};

export const useIsSkillTagsLoading = () => {
  const context = useContext(EnterpriseLearningPathSkillsContext);

  return context?.isSkillTagsLoading;
};

export const useSkillTagsError = () => {
  const context = useContext(EnterpriseLearningPathSkillsContext);

  return context?.error;
};

export default EnterpriseLearningPathSkillsContext;
